import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-main">
            <div className="footer-brand">
              <h3>simHUD</h3>
              <p>Dashboard HUD đơn giản cho ESP32-S3</p>
            </div>
          </div>
          
          <div className="footer-bottom">
            <div className="footer-copyright">
              <p>&copy; 2024 simHUD Project. Được phát triển với ❤️ bởi uProject Lab</p>
            </div>
            <div className="footer-tech">
              <span>Powered by ESP32-S3 & Arduino Platform</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
